<script setup lang="ts">
import { dateTime } from "../api";
defineProps<{ value?: string | null }>();
const precise = (value: string) =>
  new Intl.DateTimeFormat("da-DK", {
    dateStyle: "long",
    timeStyle: "long",
  }).format(new Date(value));
</script>
<template>
  <time
    v-if="value"
    :datetime="value"
    :title="precise(value)"
    class="row-updated"
    >{{ dateTime(value) }}</time
  >
  <span v-else class="muted">—</span>
</template>
<style scoped lang="scss" src="../styles/components/RowUpdated.scss"></style>
